import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { IoCloseSharp } from 'react-icons/io5'
import { Select } from '../Employee/Select/Select'
import Payroll from '../../API/Payroll/Payroll'

const SendPayslip = ({ countryList, companyId, onUploadSuccess }) => {
	console.log('companyId ', companyId)
	const [isOpen, setIsOpen] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [isUploaded, setIsUploaded] = useState(false)
	const [data, setData] = useState({
		country: 1,
		month: null,
		year: null,
	})
	const [file, setFile] = useState(null)

	const filteredCountryList = countryList?.filter(country => country.id === 1)

	const toggleModal = () => {
		setIsOpen(!isOpen)
		setData({ country: null, month: null, year: null })
		setFile(null)
		setIsUploaded(false)
		setIsLoading(false)
	}

	const handleData = e => {
		const selectedOption = e.target.value
		setData(prev => ({
			...prev,
			[e.target.name]: selectedOption,
		}))
	}

	const handleFileChange = event => {
		const selectedFile = event.target.files[0]
		if (selectedFile) {
			setFile(selectedFile)
		}
	}

	const handleSubmit = async () => {
		setIsLoading(true)

		try {
			const respRoute = await Payroll.getFileRoute(companyId, data.country, file.name, data.month, data.year)

			const response = await Payroll.sendFile(file, respRoute)

			if (response.ok) {
				setIsUploaded(true)
				onUploadSuccess()
			} else {
				throw new Error(`Erro ao enviar arquivo: ${response.statusText}`)
			}
		} catch (error) {
			console.error('Erro ao enviar o arquivo:', error)
		} finally {
			setIsLoading(false)
		}
	}

	const isDisabled = !data.country || !data.month || !data.year || !file || isLoading

	return (
		<div>
			<div
				onClick={toggleModal}
				className='tw-rounded-xl tw-cursor-pointer tw-px-4 tw-py-2 tw-bg-purple-500 tw-text-sm tw-flex tw-items-center tw-text-white tw-whitespace-nowrap'
			>
				<FaPlus size={14} className='tw-mr-2' />
				Cargar Nómina
			</div>

			{isOpen && (
				<div className='tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-justify-center tw-items-center tw-z-50'>
					<div className='tw-bg-white tw-rounded-lg tw-shadow-lg tw-w-2/5 tw-p-6 tw-relative'>
						<div className='tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-3 tw-mb-4'>
							<h2 className='tw-text-lg tw-font-medium'>Enviar Nómina</h2>

							<IoCloseSharp
								size={22}
								onClick={toggleModal}
								className='tw-text-gray-500 hover:tw-text-gray-700 tw-flex tw-items-center tw-cursor-pointer'
							/>
						</div>

						{isUploaded ? (
							<div className='tw-flex tw-flex-col tw-items-center tw-space-y-4'>
								<p className='tw-text-green-600 tw-font-medium'>¡Archivo enviado exitosamente!</p>
								<div onClick={toggleModal} className='tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-cursor-pointer'>
									Cerrar
								</div>
							</div>
						) : (
							<div>
								<div className='tw-space-y-4'>
									<Select placeholder='País' list={filteredCountryList} onChange={handleData} name='country' value={data.country} />

									<div className='tw-flex tw-flex-col tw-relative tw-mt-1'>
										<div className='tw-h-[45px] tw-w-full border tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-px-3 tw-cursor-pointer'>
											<input
												type='month'
												name='month'
												value={data.month ? `${data.year}-${data.month}` : ''}
												onChange={e => {
													const [year, month] = e.target.value.split('-')
													setData({ ...data, month, year })
												}}
												className='tw-border-none tw-bg-transparent tw-text-gray-700 tw-w-full tw-outline-none'
											/>
										</div>
									</div>

									<div className='tw-space-y-4'>
										<div className='tw-text-gray-400 tw-text-sm'>Asegúrate de llenar todos los datos correctamente para evitar errores.</div>
										<label
											htmlFor='file-upload'
											className='tw-w-full tw-border tw-rounded-lg tw-px-4 tw-py-6 tw-bg-gray-50 tw-text-sm tw-text-center tw-cursor-pointer tw-text-purple-500'
										>
											<span className='tw-underline'>{file ? file.name : 'Cargar Arquivo'}</span>
											<input id='file-upload' type='file' className='tw-hidden' onChange={handleFileChange} />
										</label>
									</div>
								</div>

								<div className='tw-flex tw-justify-end tw-gap-4 tw-mt-6'>
									<div type='button' onClick={toggleModal} className='tw-bg-gray-200 tw-text-gray-700 tw-px-4 tw-py-2 tw-rounded-lg'>
										Cancelar
									</div>

									<div
										onClick={handleSubmit}
										disabled={isDisabled}
										className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg ${isDisabled ? 'tw-opacity-50' : 'tw-cursor-pointer'}`}
									>
										{isLoading ? 'Subindo...' : 'Crear'}
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}

export default SendPayslip
